import { ManageCompanyPage } from './components'

const ManageCompany = () => <ManageCompanyPage />

export default ManageCompany
